import React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { compose } from 'redux';
import { RecentHistory } from '../../model/recentHistory';
import { SearchType } from '../../model/search';
import { convertContentRatingToSearchResult, SearchResult } from '../../model/searchResult';
import { User } from '../../model/user';
import { IRootState } from '../../reducer';
import { openFeedbackModal, openPaidDiseaseModal } from '../../reducer/globalModal/actions';
import { ResultItem } from '../menu/menu-components';
import './history-recent.scss';

export interface Props extends RouteComponentProps<{}> {
    t: any;
    history: any;
    recents: RecentHistory[];
    account: User;
    openPaidDiseaseModal: () => void;
    openFeedbackModal: () => void;
}

const HistoryRecentScreen = (props: Props) => {
    console.log({teste: props.recents})
    const onClickItem = (item: SearchResult): void => {
        if (item.isPaid && !(props.account.customer && props.account.customer.hasSubscription)) {
            props.openPaidDiseaseModal();
            return;
        }
        switch (item.type) {
            case SearchType.DISEASE:
                props.history.push(`/disease/${item.id}`);
                break;
            case SearchType.MEDICINE_LEAFLET:
                props.history.push(`/smart-bulas/${item.id}`);
                break;
            case SearchType.ILLUSTRATED_PROCEDURE:
                props.history.push(`/procedure/${item.id}`);
                break;
            case SearchType.MEDICAL_CALCULATOR:
                props.history.push(`/calculator/${item.id}`);
                break;
            case SearchType.MEDICAL_SCORE:
                props.history.push(`/scores/${item.id}`);
                break;
            case SearchType.MEDICAL_CRITERIA:
                props.history.push(`/criteria/${item.id}`);
                break;
            case SearchType.CID:
                props.history.push(`/cid/${item.id}`);
                break;
            case SearchType.SEMIOLOGY:
                props.history.push(`/semiology/${item.id}`);
                break;
            case SearchType.PEDIATRIC_DOSE:
                props.history.push(`/pediatric-dose/${item.id}`);
                break;
            case SearchType.LABORATORY:
                props.history.push(`/laboratory/${item.id}`);
                break;
            case SearchType.SUS:
                props.history.push(`/sus/${item.id}`);
                break;
            default:
                props.history.push('/construction');
        }
    };

    return (
        <div className="screen-container">
            <div className="content-container" style={{ alignItems: 'center' }}>
                <div className="results">
                    <div className="content-header">
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div className="recent-icon" />
                            <span className="content-title">{props.t('specialty.recent')}</span>
                        </div>
                    </div>
                    {props.recents.map(convertContentRatingToSearchResult).map((it, index) => (
                        <ResultItem
                            key={index}
                            result={it}
                            index={index}
                            onClick={onClickItem}
                            hasSubscription={props.account.customer && props.account.customer.hasSubscription}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = ({ authentication, recentHistory }: IRootState) => ({
    recents: recentHistory.ordenedRecents,
    account: authentication.account
});

const mapDispatchToProps = {
    openPaidDiseaseModal,
    openFeedbackModal
};

export default compose(connect(mapStateToProps, mapDispatchToProps), withTranslation())(HistoryRecentScreen) as React.ComponentType<any>;
